import { z } from 'zod';
import { TextKey } from '@mews-commander/enums';
import { RoutingRuleOrderItemConsumptionPeriodType, RoutingRuleTriggerType } from '@mews-commander/data-access';
import { RoutingRulesFormStepName, TimingFieldName } from '../types';

export const timingSchema = (existingNames: string[]) =>
    z.object({
        [RoutingRulesFormStepName.Timing]: z.object({
            [TimingFieldName.Name]: z
                .string()
                .trim()
                .min(1, { message: TextKey.RoutingRulesFormNameValidationMessage })
                .max(255)
                .refine((name) => !name || !existingNames.includes(name), {
                    message: TextKey.RoutingRulesFormDuplicateNameValidationMessage,
                }),
            [TimingFieldName.Description]: z.string().max(1000).optional(),
            [TimingFieldName.TriggerTiming]: z.nativeEnum(RoutingRuleTriggerType),
            [TimingFieldName.ConsumptionDate]: z.nativeEnum(RoutingRuleOrderItemConsumptionPeriodType).optional(),
            [TimingFieldName.TriggerDay]: z.number().optional(),
            [TimingFieldName.TriggerTime]: z.string().optional(),
        }),
    });

export type TimingSchemaFormValues = z.infer<ReturnType<typeof timingSchema>>;
